import { render, staticRenderFns } from "./ArrivalStatusChangeAction.vue?vue&type=template&id=617ba965"
import script from "./ArrivalStatusChangeAction.vue?vue&type=script&lang=js"
export * from "./ArrivalStatusChangeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports